var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-icon",style:({
        backgroundColor: _vm.uniqueColorBackground
    })},[(_vm.photo)?_c('img',{staticClass:"w-100 h-100",attrs:{"src":_vm.photoUpdated || _vm.photo}}):_c('span',[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }